import { render, staticRenderFns } from "./CouponUseRecord.vue?vue&type=template&id=520bf777&"
import script from "./CouponUseRecord.vue?vue&type=script&lang=js&"
export * from "./CouponUseRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports